export enum TeaserSegment {
    SegmentA = 1,
    SegmentB = 2,
}

export const LaunchDarklyShowTeaserKey = 'ShowTeaser';
